import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';

@Component({
  selector: 'app-manual-orientacao-proposta',
  templateUrl: './manual-orientacao-proposta.component.html',
  styleUrls: ['./manual-orientacao-proposta.component.scss'],
})
export class ManualOrientacaoPropostaComponent implements OnInit {
  tipoProdutoEnum = TipoProduto_E_OperadoraEnum;
  @Input() tipoProduto!: TipoProduto_E_OperadoraEnum;

  @Input() dadosOperadoraDM!: any;
  @Input() dadosOperadoraCabecalho!: any;
  constructor(private router: Router) {}
  operadoraVM: any;
  logoOperadora: string = '';

  ngOnInit(): void {
    this.operadoraVM = this.carregarDadosOperadora();
  }

  carregarDadosOperadora(): string {
    const cnpjOperadoraFiltro =
      (this.dadosOperadoraCabecalho && this.dadosOperadoraCabecalho?.cnpjOperadora) ||
      (this.dadosOperadoraDM && this.dadosOperadoraDM.operatorObject.cnpj);
    if (!cnpjOperadoraFiltro) {
      return '../../../../../../assets/app-assets/images/logos-empresas/default.png';
    }

    // Busca os dados da operadora pelo CNPJ
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(cnpjOperadoraFiltro);

    // Retorna o logo dos dados ou um padrão
    return dadosOperadora;
  }
}
